import React, { useState } from 'react';
import { FaSave, FaTimes } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { projectAPI } from '../../utils/api';

export default function ProjectCreate({ onClose, onSubmit, project = null }) {
  const [form, setForm] = useState({
    project_id:   project?.project_id   || '',
    name:         project?.name         || '',
    project_year: project?.project_year || '',
    is_active:    project
      ? (project.is_active === true || project.is_active === 1 || project.is_active === 'true' ? 'true' : 'false')
      : 'true',
  });
  const [loading, setLoading] = useState(false);

  const set = field => e => setForm(p => ({ ...p, [field]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.project_id.trim()) {
      Swal.fire({ icon: 'error', title: 'Validation', text: 'Project code is required' });
      return;
    }
    if (!form.name.trim()) {
      Swal.fire({ icon: 'error', title: 'Validation', text: 'Project name is required' });
      return;
    }
    setLoading(true);
    try {
      const payload = {
        project_id:   form.project_id,
        name:         form.name,
        project_year: form.project_year || null,
        is_active:    form.is_active === 'true',
      };
      if (project?.id) {
        await projectAPI.update(project.id, payload);
      } else {
        await projectAPI.create(payload);
      }
      onSubmit && onSubmit();
      Swal.fire({ icon: 'success', title: project?.id ? 'Project updated' : 'Project created', timer: 1800, showConfirmButton: false });
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Error', text: err?.response?.data?.error || err.message });
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit}>
      <div className="eduss-global-modal-field-grid">
        <div className="eduss-global-modal-field">
          <label>Project Code *</label>
          <input
            value={form.project_id}
            onChange={set('project_id')}
            placeholder="e.g. 25-26/PRJ-001"
            disabled={!!project?.id}
            required
          />
        </div>
        <div className="eduss-global-modal-field">
          <label>Project Name *</label>
          <input
            value={form.name}
            onChange={set('name')}
            placeholder="e.g. Free Distribution 2025-26"
            required
          />
        </div>
        <div className="eduss-global-modal-field">
          <label>Academic Year</label>
          <input
            value={form.project_year}
            onChange={set('project_year')}
            placeholder="e.g. 25-26"
            maxLength={7}
          />
        </div>
        <div className="eduss-global-modal-field">
          <label>Status</label>
          <select value={form.is_active} onChange={set('is_active')}>
            <option value="true">Active</option>
            <option value="false">Inactive</option>
          </select>
        </div>
      </div>

      <div className="eduss-global-modal-actions">
        <button type="button" className="eduss-global-modal-btn cancel" onClick={onClose} disabled={loading}>
          <FaTimes /> Cancel
        </button>
        <button type="submit" className="eduss-global-modal-btn save" disabled={loading}>
          <FaSave /> {loading ? 'Saving…' : project?.id ? 'Update Project' : 'Create Project'}
        </button>
      </div>
    </form>
  );
}
